<page-loader *ngIf="isLoading"></page-loader>
<div class="page-section series-form-page" *ngIf="!isLoading">
	<div class="app-l-page__navigation">
		<div class="app-l-page__previous" (click)="onCancel()">
			<button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
				<svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
			</button>
		</div>
		<div class="app-l-page__breadcrumbs">
			<ul class="breadcrumbs-list">
				<li class="breadcrumbs-list-item">
					<a [routerLink]="['/admin/user-listing']">Users</a>
				</li>
				<li class="breadcrumbs-list-item app-l-current-page">
					Create User
				</li>
			</ul>
		</div>
	</div>

	<div class="page-section-content">
		<h1>Create User</h1>

		<form [formGroup]="userCreateForm" (ngSubmit)="onSave()">
			<div class="form-row">
				<div class="app-c-form-group">
					<label class="app-c-form--label">Full Name</label>
					<input class="app-c-form-control" type="text" formControlName="fullName" />
					<div class="error-message" *ngIf="f.fullName.touched && f.fullName.errors?.required">
						Full name is required
					</div>
				</div>

				<div class="app-c-form-group">
					<label class="app-c-form--label">Email</label>
					<input class="app-c-form-control" type="text" formControlName="email" />
					<div class="error-message" *ngIf="f.email.touched && !f.email.valid">
						Invalid email
					</div>
					<p class="hint-text">Use comma delimited list if creating multiples.</p>
				</div>
			</div>

			<div class="form-row">
				<div class="app-c-form-group">
					<label class="app-c-form--label">Status</label>
					<select class="app-c-form-control" formControlName="status">
						<option value="approved">Approved</option>
						<option value="disabled">Disabled</option>
					</select>
				</div>

				<div class="app-c-form-group">
					<label class="app-c-form--label">Role</label>
					<select class="app-c-form-control" formControlName="roleId"
						(change)="onRoleChange()">
						<option *ngFor="let role of roles" [value]="role.id">{{ role.name }}</option>
					</select>
				</div>
			</div>

			<div class="form-row">
				<div class="app-c-form-group">
					<label class="app-c-form--label">Timezone</label>
					<select class="app-c-form-control" formControlName="timezone">
						<option value="">Select this user's timezone</option>
						<option *ngFor="let timezone of timezones" [value]="timezone.key">
							{{ timezone.text }}
						</option>
					</select>
				</div>

				<!-- Single org select for non-RM, non-Admin roles -->
				<div class="app-c-form-group" *ngIf="userCreateForm.value.roleId !== 6 && userCreateForm.value.roleId !== 7">
					<label class="app-c-form--label">Organization</label>
					<select class="app-c-form-control" formControlName="orgId">
						<option [value]="null">None</option>
						<option *ngFor="let org of organizations" [value]="org.id">
							{{ org.name }}
						</option>
					</select>
				</div>
			</div>

			<!-- Multi-org select for Relationship Managers -->
			<div class="app-c-form-group" *ngIf="userCreateForm.value.roleId === 6">
				<label class="app-c-form--label">Organizations</label>
				<multiselect-autocomplete
					placeholder="Select organization"
					[formControl]="organizationDataForm.controls.orgId"
					[items]="multiSelOrgs"
					[formValue]="organizationDataForm.value.orgId"
					(onSelectItems)="onSelectOrgs($event)">
				</multiselect-autocomplete>
			</div>

			<div class="form-row">
				<div class="app-c-form-group">
					<label class="app-c-form--label">Password</label>
					<div class="password-field">
						<input class="app-c-form-control" [type]="passwordType"
							formControlName="password" />
						<button type="button" class="password-toggle" (click)="onClickPassword()">
							<i [ngClass]="passwordType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
						</button>
					</div>
					<div class="error-message" *ngIf="f.password.touched && f.password.errors?.required">
						Password is required
					</div>
					<div class="error-message" *ngIf="f.password.touched && !f.password.errors?.required && !f.password.valid">
						Password must be 8-32 characters
					</div>
				</div>
			</div>

			<div class="checkbox-row">
				<label class="checkbox-label">
					<input type="checkbox" formControlName="notificationOn" />
					Receive Notifications
				</label>
			</div>

			<div class="checkbox-row">
				<label class="checkbox-label">
					<input type="checkbox" formControlName="lockedRole" />
					Lock role (useful for SSO)
				</label>
			</div>

			<div class="form-actions">
				<button type="button" class="app-c-btn app-c-btn--secondary app-c-btn--curve"
					(click)="onCancel()">Cancel</button>
				<button type="submit" class="app-c-btn app-c-btn--primary app-c-btn--curve">Save</button>
			</div>
		</form>
	</div>
</div>
